module.exports = __webpack_public_path__ + "img/8b4f4ae5adb5258e1db9ff458b2d35d.ddc0fe42.jpg";